<template>
  <lord-icon
      class="lord-icon"
      :src="iconSource"
      :trigger="trigger"
      :colors="getColors"
      style="min-width: 24px; min-height: 24px"
      stoke="100"
      @mouseover="$emit('trigger')"
  />
</template>

<script>
import {mapGetters} from "vuex";

const baseUrl = 'https://cdn.lordicon.com/';

const questionMark = 'meypkgwe';

export default {
  name: 'ELordIcon',
  props: {
    trigger: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    primaryColor: {
      type: String,
      default: '#196CAE',
    },
    secondaryColor: {
      type: String,
      default: '#196CAE',
    },
  },
  emits: ['trigger'],

  computed: {
    ...mapGetters({
      checkIfThemeIsActive: 'theme/checkIfThemeIsActive',
      availableThemes: 'theme/getAvailableThemes',
    }),

    getColors() {
      let primaryColor;
      let secondaryColor;

      if (this.checkIfThemeIsActive(this.availableThemes.Kabel24)) {
        primaryColor = '#7963B7';
        secondaryColor = '#7963B7';
      } else {
        primaryColor = this.primaryColor;
        secondaryColor = this.secondaryColor;
      }

      return 'primary:' + primaryColor + ',' + 'secondary:' + secondaryColor;
    },

    iconSource() {
      switch (this.icon) {
        case 'questionMark':
          return baseUrl + questionMark + '.json';
        default:
          throw new Error('LordIcon not defined');
      }
    },
  },
  mounted() {
    const element = document.getElementById('lordIconScript');

    if (element) {
      return;
    }

    let lordIconScript = document.createElement('script');
    lordIconScript.id = 'lordIconScript';
    lordIconScript.setAttribute(
        'src',
        'https://cdn.lordicon.com/libs/mssddfmo/lord-icon-2.1.0.js'
    );
    document.head.appendChild(lordIconScript);
  },
};
</script>

<style scoped lang="scss">
.lord-icon {
  cursor: pointer;
}
</style>
